import { render, staticRenderFns } from "./ReportMove.vue?vue&type=template&id=4b812bbe"
import script from "./ReportMove.vue?vue&type=script&lang=js"
export * from "./ReportMove.vue?vue&type=script&lang=js"
import style0 from "./ReportMove.vue?vue&type=style&index=0&id=4b812bbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports